import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, SplitText);

// Fade Up
gsap.utils.toArray(".fade-up").forEach((el) => {
    gsap.from(el, {
        scrollTrigger: {
            trigger: el,
            start: "top 85%",
            once: true,
        },
        y: 30,
        opacity: 0,
        duration: 0.8,
        ease: "power2.out",
    });
});

// Fade Left
gsap.utils.toArray(".fade-left").forEach((el) => {
    gsap.from(el, {
        scrollTrigger: {
            trigger: el,
            start: "top 85%",
            once: true,
        },
        x: -40,
        opacity: 0,
        duration: 0.8,
        ease: "power2.out",
    });
});

// Fade Right
gsap.utils.toArray(".fade-right").forEach((el) => {
    gsap.from(el, {
        scrollTrigger: {
            trigger: el,
            start: "top 85%",
            once: true,
        },
        x: 40,
        opacity: 0,
        duration: 0.8,
        ease: "power2.out",
    });
});

// Hero only
gsap.from(".hero-title", {
    y: 30,
    opacity: 0,
    duration: 1.2,
    ease: "power2.out",
});

// Scroll color reveal (word-level)
gsap.utils.toArray(".scroll-color-reveal").forEach((el) => {
    SplitText.create(el, {
        type: "words",
        onSplit(self) {
            gsap.fromTo(
                self.words,
                { color: "#DADEE8", opacity: 0 },
                {
                    color: "#02048D",
                    opacity: 1,
                    stagger: 0.05,
                    ease: "none",
                    scrollTrigger: {
                        trigger: el,
                        start: "top 90%",
                        end: "top 40%",
                        scrub: true,
                    },
                }
            );
        },
    });
});

// Logo grid
gsap.utils.toArray(".logo-grid").forEach((el) => {
    gsap.from(el.children, {
        scrollTrigger: {
            trigger: el,
            start: "top 85%",
            once: true,
        },
        y: 15,
        opacity: 0,
        stagger: 0.12,
        duration: 1.1,
        ease: "power2.out",
    });
});
